if(typeof _GIRL_CONF['dora']['game_memory']=='undefined'){_GIRL_CONF['dora']['game_memory']={};};
_GIRL_CONF['dora']['game_memory']['face']={left:563,top:121,width:129,height:152};
_GIRL_CONF['dora']['game_memory']['hair']={left:450,top:9,width:340,height:333};
_GIRL_CONF['dora']['game_memory']['hand1']={left:472,top:361,width:342,height:197};
_GIRL_CONF['dora']['game_memory']['hand2']={left:504,top:491,width:325,height:125};
_GIRL_CONF['dora']['game_memory']['item1']={left:186,top:247,width:228,height:438};
_GIRL_CONF['dora']['game_memory']['item2']={left:868,top:370,width:146,height:293};
_GIRL_CONF['dora']['game_memory']['tit']={left:653,top:339,width:109,height:112};
